import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from '../email-template/event.interface';

export interface RcsModel extends BaseModel {
  variables?: { [key: string]: string } | RcsVariables;
}

export interface RcsVariables {
  text: string;
  image_url: string;
  cta_text: string;
  cta_link: string;
}

export class RcsInitVariables implements RcsVariables {
  text = '';
  image_url = '';
  cta_text = '';
  cta_link = '';
}

export class RcsInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new RcsInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
